import React from 'react';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import UserCard from '../../../../../components/mazraeKit/cards/userCard';
import useGetMyStoreComments from '../../../../../services/hookService/store/myStore/useGetComments/useGetComments';
import {useParams} from 'react-router-dom';
import DotsLoading from '../../../../../components/dotsLoading';
import ImageNotfound from '../../../../../assets/image/sponsor/404.svg';
const MyStoreComments = () => {
  const {guid} = useParams();
  const {data, isLoading} = useGetMyStoreComments({guid});
  return (
    <div className="flex flex-col justify-between w-full h-full relative">
      <CustomHeader
        preIcon="icon-nameArrow---Right"
        title="دیدگاه مشتریان"
        isActiveRightIcon
      />
      <section className="w-full h-full flex flex-col overflow-y-auto px-3 gap-2 py-3">
        {isLoading ? (
          <DotsLoading />
        ) : (
          <>
            {data?.length === 0 ||
              (!data && (
                <div className="d-flex pt-5 gap-2 justify-center items-center flex-col w-full h-full">
                  <img
                    width="100px"
                    src={ImageNotfound}
                    alt="empty msg"
                  />
                  <p className="text-gray-900 font-Regular text-md">
                    فعلا هیچ دیدگاهی ثبت نشده است
                  </p>
                </div>
              ))}
            {data?.map((item, index) => (
              <UserCard
                cardWrapperClassName="!w-full"
                rate={item.rate}
                key={item.guid}
                description={item.text}
                name={item.store.title}
              />
            ))}
          </>
        )}
      </section>
      <MainFooter />
    </div>
  );
};

export default MyStoreComments;
